import React from "react";
import { Alert, Box, Typography, Button } from "@mui/material";
import { useStyles } from "../styles/MainNavbarStyles";
import { useNavigate } from "react-router-dom";

const SubscriptionBanner = () => {
    const classes = useStyles();
    const navigate = useNavigate();
    return (
        <Alert
            icon={false}
            sx={{
                height: "72px",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                bgcolor: "background.paper",
                borderRadius: "0px"
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: "18px"
                }}
            >
                <Typography className={classes.purchaseSubscriptionText}>
                    Ready to get started?
                </Typography>
                <Button
                    variant="contained"
                    className={classes.purchaseSubscriptionButton}
                    onClick={() => navigate("/checkout/reactivate")}
                >
                    Purchase subscription
                </Button>
            </Box>
        </Alert>
    );
};

export default SubscriptionBanner;
